import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TimelineLite } from 'gsap';

// Assets
import { brandColors, fonts, device } from '../../styles/variables';

const Number = styled.div`
  ${({ color }) => `
    color: ${color};
    font-family: ${fonts.monterrat};
    font-weight: bold;
    text-align: center;
    font-size: 80px;
    line-height: 110px;
    @media ${device.tablet} {
      font-size: 130px;
      line-height: 159px;
    }
    @media ${device.laptop} {
      font-size: 200px;
      line-height: 244px;
    }
  `};
`;

class Count extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { count: 0 };
    this._count = 0;
    this.maxCount = props.maxCount;
    this.timeline = new TimelineLite();
    this.addSymbol = props.addSymbol;
  }

  componentDidMount() {
    const { isVisible, staticCount } = this.props;
    if (!staticCount && isVisible) {
      this.animation();
    }

    if (staticCount) {
      this.setState({ count: this.maxCount });
    }
  }

  componentDidUpdate(prevProps) {
    const { isVisible, staticCount } = this.props;
    if (!staticCount && isVisible && prevProps.isVisible !== isVisible) {
      this.animation();
    }
  }

  componentWillUnmount() {
    this.timeline.stop();
  }

  animation() {
    this.timeline.to(this, 2.5, {
      _count: this.maxCount,
      onUpdate: () => this.setState({ count: ~~this._count })
    });
  }

  render() {
    const { color, className, addSymbol } = this.props;
    const { count } = this.state;

    return (
      <Number className={className} color={color}>
        {count}
        {addSymbol}
      </Number>
    );
  }
}

Count.defaultProps = {
  maxCount: 0,
  color: brandColors.white,
  isVisible: false,
  staticCount: false,
  className: '',
  addSymbol: ''
};

Count.propTypes = {
  maxCount: PropTypes.number,
  color: PropTypes.string,
  isVisible: PropTypes.bool,
  staticCount: PropTypes.bool,
  className: PropTypes.string,
  addSymbol: PropTypes.string
};

export default connect()(Count);



// WEBPACK FOOTER //
// ./src/components/Counter/Count.jsx